<template>
    <div>
        <base-dropdown :position="'right'">
            <template slot="title">
                <div class="media align-items-center custom-media-nav-size" slot="title">
                    <i class="fas fa-copyright text-color-wallet"></i>
                    <div :class="['media-body ml-2 d-none d-md-block d-lg-block pr-1', { 'text-color-wallet': !load_wallet_balances }]">
<!--                        <span v-bind:style="{color: this.$THEME.primaryColor}" :class="(this.$THEME.primaryColor?'':'text-blue')">-->
<!--                            <i class="fas fa-circle-notch fa-spin"></i>-->
<!--                        </span>-->
                        <span class="mb-0 text-sm font-weight-bold color-text-li" >
                            {{ $store.state.userInfo.balance }}
                            <p class="mb-0 small text-right">เครดิต</p>
                        </span>
                    </div>
                </div>
            </template>
            <template>
                <router-link to="/topupcredit" class="dropdown-item">
                    <Icon icon="mdi-wallet-plus" v-bind:style="{color: this.$THEME.primaryColor}" />
                    <span>เติมเครดิต</span>
                </router-link>
                <router-link to="/history/topupwallet" class="dropdown-item">
                    <i class="fas fa-file-alt" v-bind:style="{color: this.$THEME.primaryColor}"></i>
                    <span>ประวัติเติมเครดิต</span>
                </router-link>
                <router-link to="/history/usagewallet" class="dropdown-item">
                    <Icon icon="mdi-text-box-search" v-bind:style="{color: this.$THEME.primaryColor}" />
                    <span>ประวัติการใช้งาน</span>
                </router-link>
            </template>
        </base-dropdown>
        <ModalWithDrawCredit :withdraw_credit="withdraw_credit" />
    </div>
  </template>

  <script>
  import ModalWithDrawCredit from '@/components/Modals/ModalWithDrawCredit'
  import {
    fetchWalletBanlancesToLocalStorage,
    fetchWalletMetadataToLocalStorage,
    fetchShopMetadataToLocalStorage
  } from "@/axios/walletPayment.js"

  export default {
    name:"DropDownWallet",
    components:{
        ModalWithDrawCredit
    },

    data() {
        return {
            withdraw_credit:{
                show: false
            },
            load_wallet_balances: true,

            allow_read_wallet_info: false,
        }
    },

    created() {
        // if (
        //     (
        //         this.main_use_walletV2
        //         && this.$USER_LOGIN.get().isPaymentTypePrepaid
        //         && [
        //             this.$USER_LOGIN.get().isAdmin,
        //             this.$USER_LOGIN.get().isMember
        //         ].includes(true)
        //     )
        //     || !this.main_use_walletV2
        // ) {
        //     this.allow_read_wallet_info = true
        // }
    },

    mounted() {
        if (this.allow_read_wallet_info) {
            fetchWalletBanlancesToLocalStorage(this.main_use_walletV2).then(res => {
                this.$WALLET.balance           = res.balance
                this.$WALLET.peg_balance       = res.peg_balance
                this.$WALLET.available_balance = res.available_balance
            })
            .catch()
            .finally(() => {
                this.load_wallet_balances = false
            });

            fetchWalletMetadataToLocalStorage(this.main_use_walletV2)
                .catch();
        }

        fetchShopMetadataToLocalStorage()
            .catch();
    },
  }
  </script>
